export default __webpack_public_path__ + "static/media/checkMarkLogo.2a913a5f.svg";